import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IoClose } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import logo from "../assets/logo/logo.png";
import { useNavigate } from 'react-router-dom';
import { FaChevronLeft } from 'react-icons/fa';



function Navbar() {

    const [isVisible, setIsVisible] = useState(true);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [menuTransition, setMenuTransition] = useState(false);
    const [hideLink, setHideLink] = useState(false);

    const location = useLocation();
    const isActive = (path) => location.pathname === path;
    const navigate = useNavigate();

    const lastScrollY = useRef(window.scrollY);

    const backButtonPages = [
        '/testa-collo/',
        '/spalla/',
        '/ginocchio/',
        '/anca-bacino/',
        '/caviglia-piede/',
        '/schiena/',
    ];

    const showBackButton = backButtonPages.includes(location.pathname);

    useEffect(() => {
        const handleScroll = () => {
            if (!isMenuOpen) {
                setIsVisible(window.scrollY < lastScrollY.current);
                lastScrollY.current = window.scrollY;
            }

            if (window.scrollY < 800) {
                setIsVisible(true);
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => window.removeEventListener('scroll', handleScroll);
    }, [isMenuOpen]);

    useEffect(() => {
        document.body.style.overflow = isMenuOpen ? 'hidden' : 'auto';
    }, [isMenuOpen]);


    const handleMenuOpen = () => {
        setIsMenuOpen(true);
        setHideLink(false);
        setTimeout(() => {
            setMenuTransition(true);
        }, 500);
    };

    const handleMenuClose = () => {
        setHideLink(true);
        setTimeout(() => {
            setMenuTransition(false);
            setIsMenuOpen(false);
        }, 450);
    };

    return (
        <>
        {/* <nav className='relative' aria-label="Navigation principale">
            <div className={`mix-blend-difference text-white hidden xl:block fixed z-40 top-0 left-0 w-full transition-transform duration-300 
                ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
                <div className={`bg-transparent flex xl:justify-center justify-end items-center p-10`}>
                    <Link to="/" className={`uppercase panoragraf-light mx-6 ${isActive('/') ? 'underline-animate-active' : 'underline-animate'}`}>Home</Link>
                    <Link to="/staff/" className={`uppercase panoragraf-light mx-6 ${isActive('/staff/') ? 'underline-animate-active' : 'underline-animate'}`}>Chi siamo</Link>
                    <Link to="/fisioterapia/" className={` uppercase panoragraf-light mx-6 ${isActive('/fisioterapia/') ? 'underline-animate-active' : 'underline-animate'}`}>fisioterapia</Link>
                    <Link to="/formazione/" className={`uppercase panoragraf-light mx-6 ${isActive('/formazione/') ? 'underline-animate-active' : 'underline-animate'}`}>formazione</Link>
                    <Link to="/tecnologie/" className={`uppercase panoragraf-light mx-6 ${isActive('/tecnologie/') ? 'underline-animate-active' : 'underline-animate'}`}>tecnologie</Link>
                    <Link to="/servizi/" className={`uppercase panoragraf-light mx-6 ${isActive('/servizi/') ? 'underline-animate-active' : 'underline-animate'}`}>servizi</Link>
                </div>
            </div>

            <div className={`block xl:hidden fixed z-50 top-0 left-0 w-full transition-transform duration-300 ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
                <div className={`flex xl:justify-center justify-end items-center text-white p-10`}>

                    {showBackButton && (<div className='fixed top-[15px] left-[15px] z-50'>
                        <button onClick={() => navigate(-1)}
                            // className={`px-8 py-2 uppercase border border-slate-50 text-slate-50 progress-button-light transition duration-300 ease-in-out `}
                            className='flex border p-2 rounded bg-[#65806E] border-[#65806E]'
                        >
                            <FaChevronLeft className='mt-1' /> <span className='pl-1'>INDIETRO</span>
                        </button>
                    </div>
                    )}
                    <button className="w-6 h-6" onClick={handleMenuOpen}>
                        <RxHamburgerMenu className='text-3xl text-mcare' />
                    </button>
                    <nav className={`z-50 flex flex-col justify-top items-center absolute top-0 right-0 w-full h-full bg-black transition-all duration-[500ms] ease-in ${isMenuOpen ? 'opacity-100' : 'opacity-0'} ${isMenuOpen ? 'translate-y-0' : '-translate-y-full'} ${isMenuOpen && 'h-screen'}`}>
                        {menuTransition && (
                            <>
                                <Link to="/" data-aos="fade-right" data-aos-duration="250" onClick={handleMenuClose} className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 mb-2 mt-36 ${isActive('/') ? 'text-mcare' : ''}`}>Home</Link>
                                <Link to="/staff/" data-aos="fade-right" data-aos-duration="500" onClick={handleMenuClose} className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 my-2 ${isActive('/staff/') ? 'text-mcare' : ''}`}>chi siamo</Link>
                                <Link to="/fisioterapia/" data-aos="fade-right" data-aos-duration="750" onClick={handleMenuClose} className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 my-2 ${isActive('/fisioterapia/') ? 'text-mcare' : ''}`}>fisioterapia</Link>
                                <Link to="/formazione/" data-aos="fade-right" data-aos-duration="1000" onClick={handleMenuClose} className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 my-2 ${isActive('/formazione/') ? 'text-mcare' : ''}`}>Formazione</Link>
                                <Link to="/tecnologie/" data-aos="fade-right" data-aos-duration="1250" onClick={handleMenuClose} className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 my-2 ${isActive('/tecnologie/') ? 'text-mcare' : ''}`}>Tecnologie</Link>
                                <Link to="/servizi/" data-aos="fade-right" data-aos-duration="1500" onClick={handleMenuClose} className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 my-2 ${isActive('/servizi/') ? 'text-mcare' : ''}`}>Servizi</Link>
                                <button className="absolute top-0 right-0 w-6 h-6 text-white m-10" onClick={handleMenuClose}>
                                    <IoClose className='text-3xl text-mcare' />
                                </button>
                                <img src={logo} alt="Logo" className="w-40 h-fit mt-20" data-aos="fade-in" data-aos-delay="800" />
                            </>
                        )}

                    </nav>

                </div>
            </div>
        </nav> */}


        <nav className='relative' aria-label="Navigation principale">
            <div className={`text-white w-full fixed z-40 top-0 left-0 `}> 
                <div className={`bg-transparent justify-center items-center p-10 transition-transform duration-300 hidden xl:flex 
                    ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
                    <Link to="/" className={`[text-shadow:0_2px_2px_rgba(0,0,0,1)] uppercase panoragraf-light mx-6 ${isActive('/') ? 'underline-animate-active' : 'underline-animate'}`}>Home</Link>
                    <Link to="/staff/" className={`[text-shadow:0_2px_2px_rgba(0,0,0,1)] uppercase panoragraf-light mx-6 ${isActive('/staff/') ? 'underline-animate-active' : 'underline-animate'}`}>Chi siamo</Link>
                    <Link to="/fisioterapia/" className={`[text-shadow:0_2px_2px_rgba(0,0,0,1)] uppercase panoragraf-light mx-6 ${isActive('/fisioterapia/') ? 'underline-animate-active' : 'underline-animate'}`}>fisioterapia</Link>
                    <Link to="/formazione/" className={`[text-shadow:0_2px_2px_rgba(0,0,0,1)] uppercase panoragraf-light mx-6 ${isActive('/formazione/') ? 'underline-animate-active' : 'underline-animate'}`}>formazione</Link>
                    <Link to="/tecnologie/" className={`[text-shadow:0_2px_2px_rgba(0,0,0,1)] uppercase panoragraf-light mx-6 ${isActive('/tecnologie/') ? 'underline-animate-active' : 'underline-animate'}`}>tecnologie</Link>
                    <Link to="/servizi/" className={`[text-shadow:0_2px_2px_rgba(0,0,0,1)] uppercase panoragraf-light mx-6 ${isActive('/servizi/') ? 'underline-animate-active' : 'underline-animate'}`}>servizi</Link>
                </div>
            

                <div className={`flex xl:hidden justify-end items-center p-10 ${!isMenuOpen ? 'mix-blend-difference' : ''}`}>

                    {showBackButton && (
                    <div className='fixed top-0 left-[15px] z-50'>
                        <button onClick={() => navigate(-1)}
                            className='flex border p-2 rounded bg-mcare border-[#65806E]'
                        >
                            <FaChevronLeft className='mt-1' /> <span className='pl-1'>INDIETRO</span>
                        </button>
                    </div>
                    )}
                    <button className={`w-6 h-6`} onClick={handleMenuOpen}>
                        <RxHamburgerMenu className='text-3xl text-white' />
                    </button>
                    <div className={`z-50 flex flex-col justify-top items-center absolute top-0 right-0 w-full h-full bg-black transition-all duration-[500ms] ease-in 
                        ${isMenuOpen ? 'opacity-100' : 'opacity-0'} 
                        ${isMenuOpen ? 'translate-y-0' : '-translate-y-full'} 
                        ${isMenuOpen && 'h-screen'}`}>
                        {menuTransition && (
                            <>
                                <Link to="/" data-aos="fade-right" data-aos-duration="250" onClick={handleMenuClose} className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 mb-2 mt-36 ${isActive('/') ? 'text-mcare' : ''}`}>Home</Link>
                                <Link to="/staff/" data-aos="fade-right" data-aos-duration="500" onClick={handleMenuClose} className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 my-2 ${isActive('/staff/') ? 'text-mcare' : ''}`}>chi siamo</Link>
                                <Link to="/fisioterapia/" data-aos="fade-right" data-aos-duration="750" onClick={handleMenuClose} className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 my-2 ${isActive('/fisioterapia/') ? 'text-mcare' : ''}`}>fisioterapia</Link>
                                <Link to="/formazione/" data-aos="fade-right" data-aos-duration="1000" onClick={handleMenuClose} className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 my-2 ${isActive('/formazione/') ? 'text-mcare' : ''}`}>Formazione</Link>
                                <Link to="/tecnologie/" data-aos="fade-right" data-aos-duration="1250" onClick={handleMenuClose} className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 my-2 ${isActive('/tecnologie/') ? 'text-mcare' : ''}`}>Tecnologie</Link>
                                <Link to="/servizi/" data-aos="fade-right" data-aos-duration="1500" onClick={handleMenuClose} className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 my-2 ${isActive('/servizi/') ? 'text-mcare' : ''}`}>Servizi</Link>
                                <button className="absolute top-0 right-0 w-6 h-6 text-white m-10" onClick={handleMenuClose}>
                                    <IoClose className='text-3xl' />
                                </button>
                                <img src={logo} alt="Logo" className="w-40 h-fit mt-20" data-aos="fade-in" data-aos-delay="800" />
                            </>
                        )}

                    </div>

                </div>
            

            </div>
        </nav>
        </>
    );
}

export default Navbar;
